import React from 'react'

const Error = () => {
  return (
    <div className="grain min-h-screen bg-void flex items-center justify-center px-4 relative overflow-hidden">
      <div className="absolute -top-32 -right-32 w-[30rem] h-[30rem] rounded-full glow-red blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-[30rem] h-[30rem] rounded-full glow-violet blur-3xl" />
      <div className="relative z-10 text-center">
        <p className="font-Bebas text-[8rem] sm:text-[12rem] leading-none text-gradient">404</p>
        <p className="font-Bebas text-3xl sm:text-4xl text-white tracking-wide mb-3">PAGE NOT FOUND</p>
        <p className="font-poppins text-white/45 text-sm sm:text-base mb-8 max-w-sm mx-auto">
          Looks like you wandered off the map. Even Reo couldn't find this one.
        </p>
        <a
          href="/"
          className="inline-block px-8 py-4 rounded-full bg-reored text-white font-poppins font-semibold shadow-[0_0_40px_rgba(213,60,53,0.45)] hover:shadow-[0_0_60px_rgba(213,60,53,0.7)] transition-shadow duration-300"
        >
          Take me home
        </a>
      </div>
    </div>
  )
}

export default Error
